import { render } from "./SelectColumnsPage.vue?vue&type=template&id=6ea11cd4&scoped=true"
import script from "./SelectColumnsPage.vue?vue&type=script&lang=js"
export * from "./SelectColumnsPage.vue?vue&type=script&lang=js"

import "./SelectColumnsPage.vue?vue&type=style&index=0&id=6ea11cd4&lang=stylus&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ea11cd4"]])

export default __exports__